export function resolvePremiumExpiration(rawValue) {
  if (!rawValue) {
    return null;
  }

  if (typeof rawValue.toMillis === 'function') {
    return rawValue.toMillis();
  }

  if (typeof rawValue.toDate === 'function') {
    return rawValue.toDate().getTime();
  }

  if (rawValue instanceof Date) {
    return rawValue.getTime();
  }

  if (typeof rawValue === 'number') {
    return rawValue;
  }

  if (typeof rawValue === 'string') {
    const normalized = rawValue
      .replace(/[\u202f\u00a0]/g, ' ')
      .replace(/\s+at\s+/i, ' ')
      .replace(/UTC([+-]\d{1,2})/i, (_match, offset) => {
        const numericOffset = Number(offset);
        const hours = String(Math.abs(numericOffset)).padStart(2, '0');
        const sign = numericOffset >= 0 ? '+' : '-';
        return `GMT${sign}${hours}00`;
      });

    const parsed = Date.parse(normalized);
    if (!Number.isNaN(parsed)) {
      return parsed;
    }

    const numericValue = Number(rawValue);
    return Number.isNaN(numericValue) ? null : numericValue;
  }

  if (typeof rawValue === 'object') {
    if (typeof rawValue._seconds === 'number') {
      const millis = rawValue._seconds * 1000 + (rawValue._nanoseconds || 0) / 1e6;
      return millis;
    }

    if (typeof rawValue.seconds === 'number') {
      const millis = rawValue.seconds * 1000 + (rawValue.nanoseconds || 0) / 1e6;
      return millis;
    }

    if (rawValue.year && rawValue.month && rawValue.day) {
      const date = new Date(`${rawValue.year}-${String(rawValue.month).padStart(2, '0')}-${String(rawValue.day).padStart(2, '0')}`);
      return Number.isNaN(date.getTime()) ? null : date.getTime();
    }
  }

  return null;
}

